import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'campaigns';

export function useGetAllCampaigns(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetCampaign(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateCampaign() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateCampaign({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteCampaign({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
